import UnderlineTextButtonItalic from '@/components/widgets/buttons/UnderlineTextButtonItalic'
import React, { useEffect, useRef } from 'react'
import ImageSlicer from '@/components/widgets/ImageSlicer'
import { useRouter } from 'next/navigation'
import Loading from '@/components/widgets/Loading'
import { useUser } from '@/components/widgets/UserProvider'

interface SustainableLuxuryProps {
  image: string
  staticImageUrl?: string
  isDisplayDescription?:boolean
}

const SustainableLuxury: React.FC<SustainableLuxuryProps> = ({
  image,
  staticImageUrl,
  isDisplayDescription=false
}) => {
  const router = useRouter()
  const { userPageLoading } = useUser()

  return (
    <div className='relative flex flex-col md:flex-row w-full pb-[100px] pt-[12px] md:bg-white md:px-20 md:text-black mt-8 md:mt-1'>
      {userPageLoading ? (
        <div className='w-full'>
          <Loading
            classes={
              'flex-grow flex max-h-screen sm:min-h-[43px] w-[15%] mt-[25px] bg-[rgba(128,128,128,0.3)] !text-white'
            }
          />

          <Loading
            classes={
              'flex-grow flex max-h-screen sm:min-h-[60px] w-[35%] mt-[25px] bg-[rgba(128,128,128,0.3)] !text-white'
            }
          />

          <Loading
            classes={
              'flex-grow flex max-h-screen sm:min-h-[110px] mt-[25px] mr-[30px] bg-[rgba(128,128,128,0.3)] !text-white'
            }
          />

          <Loading
            classes={
              'flex-grow flex max-h-screen sm:min-h-[43px] w-[10%] mt-[25px] bg-[rgba(128,128,128,0.3)] !text-white'
            }
          />
        </div>
      ) : (
        <div className='md:w-[69%] flex flex-row md:items-start z-30 bg-red-3000'>
          <div className='flex flex-col h-full items-center md:items-start justify-center pr-6 mx-auto'>
            <div className='uppercase font-barlowLight text-[10px] md:text-[24px] tracking-[0.6px] md:tracking-[4.4px]'>
              About us
            </div>

            <div className='w-full'></div>
            <div className='font-psSemibold text-[24px] md:text-[48px] my-3 md:my-5 leading-[1.20] text-center md:text-start'>
              <span className='font-cambonLight'>Sustainable Luxury -</span>
              <br />
              <span className='font-cambonLightItalic'>The Modern Way</span>
            </div>

            {isDisplayDescription ?
              <div className='block md:hidden mb-[60px] ml-[23px]'>
                <div className='text-center font-barlowMedium text-[14px] leading-[18px]'>Vertelier is a contemporary brand with contemporary values. We like to practice more than we like to preach, offering a wide range of luxury products made ethically and sustainably for our consumers, conscious and otherwise.</div>
                <br/>
                <div className='text-center font-barlowMedium text-[14px] leading-[18px]'>With no guilt attached to the product label or the price tag, we hope to build a community that wants to be a part of all the good we want to see in this world.</div>
              </div>
            : ""}

            <div className='font-barlowLight text-[20px] mt-3 text-black hidden md:block'>
              Vertelier is a contemporary brand with contemporary values. We
              like to practice more than we like to preach, offering a wide
              range of luxury products made ethically and sustainably for our
              consumers, conscious and otherwise. With no guilt attached to the
              product label or the price tag, we hope to build a community that
              wants to be a part of all the good we want to see in this world.
            </div>

            <div className='mt-8 hidden md:block'>
              <UnderlineTextButtonItalic
                text={'Our Story'}
                color='#000'
                onClick={() => {
                  router.push('/about-us')
                }}
              />
            </div>
          </div>
        </div>
      )}

      <div className='md:w-[46%] flex flex-col items-start justify-start z-10'>
        {/* <Image
          src={image}
          alt="Sustainable Luxury"
          layout="responsive"
          width={1024}
          height={1024}
          className="object-contain w-full h-full"
        /> */}

        <ImageSlicer
          imageUrl={image}
          staticImageUrl={staticImageUrl}
          sliceCount={6}
          animationDuration={2000}
        />
      </div>
    </div>
  )
}

export default SustainableLuxury
